//Types
export const Types = {
  CREATE_USER_COLLECTION: "CREATE_USER_COLLECTION",
  UPDATE_USER_COLLECTION: "UPDATE_USER_COLLECTION",
  GET_USER_COLLECTIONS: "GET_USER_COLLECTIONS",
  GET_USER_COLLECTION: "GET_USER_COLLECTION",
  DELETE_USER_COLLECTION: "DELETE_USER_COLLECTION",
  SET_LOADING: "SET_LOADING_USER_COLLECTION",
  UPDATE_API_TOKEN: "UPDATE_API_TOKEN",
  UPDATE_JDBC_PASSWORD: "UPDATE_JDBC_PASSWORD",
  UPDATE_COLLECTION_TOKEN: "UPDATE_COLLECTION_TOKEN",
  GET_API_TOKENS: "GET_API_TOKENS",
  GET_JDBC_TOKENS: "GET_JDBC_TOKENS",
  GET_JDBC_DM_TOKENS: "GET_JDBC_DM_TOKENS",
  GET_POSTGRES_TOKENS: "GET_POSTGRES_TOKENS",
  SET_POSTGRES_LOADING: "SET_POSTGRES_LOADING_USER_COLLECTION",

};

//Reducer
const initialState = {
  userCollections: null,
  userCollection: null,
  userPostgresCollection: null,
  loading: false,
  postgresLoading: false,
};

const UserCollection = (state = initialState, action) => {
  switch (action.type) {
    case Types.CREATE_USER_COLLECTION:
      return {
        ...state,
        userCollection: action.payload,
      };

    case Types.UPDATE_USER_COLLECTION:
      return {
        ...state,
        userCollection: action.payload,
      };

    case Types.GET_USER_COLLECTIONS:
      return {
        ...state,
        userCollections: action.payload,
        loading: false,
      };

    case Types.GET_USER_COLLECTION:
      return {
        ...state,
        userCollection: action.payload,
        loading: false,
      };

    case Types.DELETE_USER_COLLECTION:
      return {
        ...state,
        userCollection: action.payload,
      };
    case Types.ACCESS_HISTORY:
      return {
        ...state,
        accessHistory: action.payload,
      };

    case Types.UPDATE_API_TOKEN:
      return {
        ...state,
        userCollection: action.payload,
      };

    case Types.UPDATE_JDBC_PASSWORD:
      return {
        ...state,
        userCollection: action.payload,
      };

    case Types.SET_LOADING:
      return {
        ...state,
        loading: true,
      };

    case Types.SET_POSTGRES_LOADING:
      return {
        ...state,
        postgresLoading: true,
      };

    case Types.GET_API_TOKENS:
      return {
        ...state,
        apiTokens: action.payload,
      };

    case Types.GET_JDBC_TOKENS:
      return {
        ...state,
        jdbcTokens: action.payload,
      };

    case Types.GET_JDBC_DM_TOKENS:
      return {
        ...state,
        jdbcDmTokens: action.payload,
      };

    case Types.GET_POSTGRES_TOKENS:
      return {
        ...state,
        userPostgresCollection: action.payload,
        postgresLoading: false,
      };

    default:
      return state;
  }
};

export default UserCollection;
